export enum EnumMovementType {
    Contratacion = 1,
    Reubicacion = 2,
    Salario = 3
}